import { apiClient, unwrap } from './client';

/**
 * Écarts d'inventaire physique — 29/09/2026.
 *
 * Les quantités arrivent en chaînes : ce sont des `Decimal` côté base, et un
 * arrondi de virgule flottante sur un comptage de stock n'a aucune excuse.
 */

export type StatutEcart = 'corrige' | 'partiel' | 'non_corrige' | 'resolu_manuellement';

export interface EcartInventaire {
  id:            string;
  declarationId: string;
  dateComptage:  string;
  articleCode:   string;
  articleType:   'matiere_premiere' | 'produit_fini';
  unite:         string;
  /** Ce que le terrain a compté. */
  quantiteComptee:  string;
  /** Ce que le système portait AU MOMENT du comptage — pas aujourd'hui. */
  quantiteSysteme:  string;
  /** Comptée − système, signé. */
  ecart:            string;
  /** Ce qui a effectivement été redressé. */
  quantiteCorrigee: string;
  statut:           StatutEcart;
  motif:            string | null;
  resoluAt:         string | null;
  resolutionNote:   string | null;
  createdAt:        string;
}

export interface ListeEcarts {
  data:   EcartInventaire[];
  resume: { total: number; ouverts: number };
}

export const inventaireApi = {
  ecarts: (params?: { statut?: string; type?: string }) =>
    apiClient.get('/inventaire/ecarts', { params }).then(unwrap<ListeEcarts>),

  resoudre: (id: string, note: string) =>
    apiClient
      .patch(`/inventaire/ecarts/${id}/resoudre`, { note })
      .then(unwrap<{ id: string; statut: StatutEcart }>),
};
